import React, { useState } from "react";
// import NavBar from "../components/NAVBAR/NavBar";
import NavBarDark from "../components/NAVBAR/NavBarDark";

import MarketplaceHero from "../components/MARKETPLACE/MarketplaceHero";
import GroupOrders from "../components/MARKETPLACE/GroupOrders";
import SellOnVenco from "../components/MARKETPLACE/SellOnVenco";
import HowItWorksMobile from "../components/MARKETPLACE/howItWorksMobile";
import HowItWorksDesktop from "../components/MARKETPLACE/howItWorksDesktop";
import Footer from "../components/FOOTER/Footer";
import FAQ from "../components/FAQ/FAQ";
import { Helmet } from "react-helmet";
import HowCTAComp from "../components/HowItWorks/HowCTAComp";


import residentNew5 from "../assets/howItWorks/residentNew5.png";
import residentNew6 from "../assets/howItWorks/residentNew6.png";
import residentNew7 from "../assets/howItWorks/residentNew7.png";
import adminGetStarted from "../assets/howItWorks/adminGetStarted.webp";
import adminSignUp from "../assets/howItWorks/adminSignup.webp";
import NewProductVote from "../components/MARKETPLACE/NewProductVote";

const faqQuestions = [
  {
    question: "What is a market day?",
    answer: <p>Market Day is when residents can place bulk orders at discounted prices. It opens every Sunday at 1:00 PM and closes on Wednesday at 11:59 PM. Orders are processed, and deliveries happen on Saturday between 10:00 AM - 4:00 PM.</p>
  },
  {
    question: "Can I add items to my order after checking out?",
    answer: <p>Once you check out, orders are processed in bulk to secure the best prices. Need something else? You can always place a second order before the window closes!</p>
  },
  {
    question: "How do I know if the threshold has been reached?",
    answer: <p>You can check the progress on the marketplace page in the Venco app. You will also receive a notification if the target is met before the window closes.</p>
  },
  {
    question: "Can I combine my order with a neighbor’s order?",
    answer: <p>Each resident must place their own order, but encouraging neighbors to join helps meet the threshold faster. You can encourage neighbours to join in purchases by sharing group items with them.</p>
  },
  {
    question: "What payment methods are accepted?",
    answer: <p>All payments are made through your Venco wallet. Please ensure your wallet is funded before placing an order.</p>
  },
  {
    question: "How do I place an order?",
    answer: <>
        <ul className="list-inside list-disc pl-4">
            <li><span>Open the Venco app.</span></li>
            <li><span>Tap on the Marketplace icon</span></li>
            <li><span>Select your items and check out before the deadline.</span></li>
        </ul>
    </>
  },
]

const residentNew = [
  {
    label: <p>Download App</p>,
    bodyContent: [
      [
        <p>
          Visit your{" "}
          <a
            href="https://play.google.com/store/apps/details?id=com.manqala.estatemanager&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-[6px] decoration-[1.5px] text-light-green-850"
          >
            App Store 
          </a>
          
          {" "}or <a
            href="https://apps.apple.com/gb/app/manqala-estate-manager/id1542447397#?platform=iphone"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-[6px] decoration-[1.5px]  text-light-green-850"
          >
            Play Store 
          </a>{" "}
          to download, and install the Venco app,
        </p>,
      ],
    ],
    image: adminGetStarted,
  },
  {
    label: `Sign up`,
    bodyContent: [
      [
        <p>
          If you are a new user, click on the{" "}
          <span className="font-bold">“sign-up”</span> button and complete the
          form with a valid email and phone number.
        </p>,
      ],
    ],
    image: adminSignUp,
  },
  {
    label: `Add Product To Cart`,
    bodyContent: [
      [
        <p>
          After successfully signing up, click on the{" "}
          <span className="font-bold">"Marketplace"</span> button on the{" "}
          <span className="font-bold">
            “Home Page”
          </span>
          of the app
        </p>,
      ],
      [
        "Search and add items into your cart.",
      ],
    ],
    image: residentNew5,
  },
  {
    label: `Place Order`,
    bodyContent: [
      [
        <p>
          Click on the{" "}
          <span className="font-bold">"Order"</span> button at the top right of the app to view your cart.
        </p>,
      ],
      [
        <p>
          Click the <span className="font-semibold">"Checkout"</span> button.
        </p>,
      ],
    ],
    image: residentNew6,
  },
  {
    label: `Confirm Order`,
    bodyContent: [
      [
        <p>
          Review the order details, then click the <span className="font-semibold">"Place Order"</span> button.
        </p>,
      ],
    ],
    image: residentNew7,
  },
];

const residentExisting = [
  {
    label: `Add Product To Cart`,
    bodyContent: [
      [
        <p>
          After successfully signing up, click on the{" "}
          <span className="font-bold">"Marketplace"</span> button on the{" "}
          <span className="font-bold">
            “Home Page”
          </span>
          of the app
        </p>,
      ],
      [
        "Search and add items into your cart.",
      ],
    ],
    image: residentNew5,
  },
  {
    label: `Place Order`,
    bodyContent: [
      [
        <p>
          Click on the{" "}
          <span className="font-bold">"Order"</span> button at the top right of the app to view your cart.
        </p>,
      ],
      [
        <p>
          Click the <span className="font-semibold">"Checkout"</span> button.
        </p>,
      ],
    ],
    image: residentNew6,
  },
  {
    label: `Confirm Order`,
    bodyContent: [
      [
        <p>
          Review the order details, then click the <span className="font-semibold">"Place Order"</span> button.
        </p>,
      ],
    ],
    image: residentNew7,
  },
];

const MarketplacePage = () => {
  const [tab, setTab] = useState(1);
  const [accordion, setAccordion] = useState(1);
  const [userType, setUserType] = useState("existing");

  return (
    <>
      <Helmet>
        <title>
          Marketplace - Venco | All-in-one Community Management Software
        </title>
        <meta
          property="og:title"
          content="Residents - Venco | All-in-one Community Management Software"
        />
        <meta
          name="twitter:title"
          content="Residents - Venco | All-in-one Community Management Software"
        />
      </Helmet>
      <NavBarDark />
      {/* <NavBar /> */}
      <MarketplaceHero />
      <GroupOrders />
      
      <section className="container mx-auto my-10 xl:py-[100px] p-4">
        <p className="font-sora text-center text-[30px] leading-[40px] font-semibold my-6 xl:my-10 xl:text-5xl xl:leading-[60px] ">
          How to Place an Order
        </p>

        {/* Section Tab */}
        {/* <div className="p-2.5 rounded-full bg-[#F8F8F7] center relative max-w-[875px] lg:mx-auto">
          <div
            className={`absolute w-1/2 bg-[#CBF07F] h-[calc(100%-20px)] rounded-full transition-all z-0 duration-500 ${
              tab === 1 ? "left-2.5" : "left-[calc(50%-10px)]"
            }`}
          ></div>
          <button
            onClick={() => {
              setTab(1);
              setAccordion(1);
              setUserType("new");
            }}
            className={`transition-all duration-300 flex-1 py-4 center font-sora font-medium text-green-500 rounded-full relative z-[1]
            text-sm lg:text-lg`}
            // ${tab === 1 ? "bg-[#CBF07F]" : "bg-transparent"}
          >
            <span className="hidden md:inline-block whitespace-pre">
              Order as a{" "}
            </span>
            New User
          </button>
          <button
            onClick={() => {
              setTab(2);
              setAccordion(1);
              setUserType("existing");
            }}
            className={`transition-all duration-300 flex-1 py-4 center font-sora font-medium text-green-500 rounded-full relative z-[1]
            text-sm lg:text-lg`}
            // ${tab === 2 ? "bg-[#CBF07F]" : "bg-transparent"}
          >
            <span className="hidden md:inline-block whitespace-pre">
              Order as an{" "}
            </span>
            Existing User
          </button>
        </div>
        <div className="h-14"></div> */}

        {/* Content Section Mobile */}

        {/* {userType === "new" && <HowItWorksMobile data={residentNew} />} */}

        {userType === "existing" && (
          <HowItWorksMobile data={residentExisting} />
        )}

        {/* {userType === "new" && (
          <HowItWorksDesktop
            accordion={accordion}
            setAccordion={setAccordion}
            data={residentNew}
            compId="placeOrder1"
          />
        )} */}

        {userType === "existing" && (
          <HowItWorksDesktop
            accordion={accordion}
            setAccordion={setAccordion}
            data={residentExisting}
            compId="placeOrder2"
          />
        )}
      </section>
      <NewProductVote />
      <HowCTAComp
        title={
          "Unlock Lower Prices by Ordering in Bulk with Neighbors."
        }
        link={"https://www.youtube.com/shorts/JzcVFpQCMRs"}
      />

      <FAQ 
        faqQuestions={faqQuestions}
      />
      <SellOnVenco />
      <Footer />
    </>
  );
};

export default MarketplacePage;
